import { pdfjs } from 'react-pdf';

/**
 * pdf.js worker configuration, shared by every react-pdf surface.
 *
 * The worker is served from our own origin rather than a CDN: browser
 * extensions and HTTPS-only modes routinely block cdnjs, which breaks PDF
 * rendering outright, and a CDN URL built from `pdfjs.version` silently points
 * at whatever version happens to be installed. `public/pdf.worker.min.js` is
 * copied from the installed pdfjs-dist by the `postinstall` script, so the
 * worker and the library can never drift apart.
 *
 * Importing this module applies the configuration; it must be imported by any
 * module that renders <Document>. It is deliberately not wired into
 * src/index.tsx: `pdfjs` pulls in all of react-pdf/pdfjs-dist, which would move
 * ~1MB out of the lazy-loaded route chunks and into the main bundle.
 */
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;
